import useGetClassificationReport from '../hooks/useGetClassificationReport'
import {ClassificationReportContext} from '../context'
import {Pagination} from '../../../utils/pagination'
import {KTCard} from '../../../_metronic/helpers'
import ClassificationReportHeader from '../sections/header/ClassificationReportHeader'
import ClassificationReportTable from '../sections/table/ClassificationReportTable'
import {useGetClassificationsDropdown} from '../hooks/useGetClassificationsDropdown'
import useGetEntityPerformanceChartData from '../hooks/useGetEntityPerformanceChartData'
import useGetProfitTrend from '../hooks/useGetProfitTrend'

function ClassificationReport() {
  const {
    reportData,
    isLoading,
    onSearch,
    filters,
    onSortingChange,
    onPageChange,
    pagination,
    onDateChange,
    onChangeClassificationFilter,
    onDownloadCSV,
  } = useGetClassificationReport()

  const {
    entityPerformanceChartData,
    isLoading: isEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters,
  } = useGetEntityPerformanceChartData('classification')

  const {classifications, isLoading: isClassificationsLoading} = useGetClassificationsDropdown()

  const {
    profitTrendChartData,
    kpiData: profitTrendKpiData,
    weeklyBreakdownData: profitTrendWeeklyBreakdownData,
    isLoading: isProfitTrendDataLoading,
    onProfitTrendIdChange,
  } = useGetProfitTrend('classification')

  const contextValue = {
    reportData,
    isLoading,
    onSearch,
    filters,
    onSortingChange,
    onPageChange,
    onDateChange,
    onChangeClassificationFilter,
    onDownloadCSV,

    classifications,
    isClassificationsLoading,

    entityPerformanceChartData,
    isEntityPerformanceChartDataLoading,
    onEntityPerformanceChartIdChange,
    onEntityPerformanceChartViewChange,
    onEntityPerformanceChartDateRangeChange,
    entityPerformanceChartFilters,

    // Profit Trend Modal Data
    profitTrendChartData,
    profitTrendKpiData,
    profitTrendWeeklyBreakdownData,
    isProfitTrendDataLoading,
    onProfitTrendIdChange,
  }

  return (
    <KTCard>
      <ClassificationReportContext.Provider value={contextValue}>
        <ClassificationReportHeader />
        <ClassificationReportTable />
        <Pagination pagination={pagination} onPageChange={onPageChange} />
      </ClassificationReportContext.Provider>
    </KTCard>
  )
}

export default ClassificationReport
